var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApiCredentialsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "themed-icon",
    d: "M10.3129 11.566L18.2529 3.62601L20.3739 5.74701L18.9599 7.16101L21.0809 9.28201L17.5459 12.818L15.4249 10.697L12.4349 13.687C12.9854 14.7463 13.139 15.9676 12.8677 17.1302C12.5965 18.2928 11.9184 19.3201 10.956 20.0264C9.99351 20.7327 8.81016 21.0715 7.61973 20.9816C6.4293 20.8916 5.31028 20.3789 4.46487 19.536C3.61902 18.6915 3.10368 17.572 3.01222 16.3802C2.92077 15.1885 3.25926 14.0034 3.96634 13.0397C4.67343 12.0761 5.70234 11.3976 6.86661 11.1272C8.03088 10.8569 9.25348 11.0125 10.3129 11.566ZM9.41386 17.414C9.60489 17.2295 9.75725 17.0088 9.86207 16.7648C9.96689 16.5208 10.0221 16.2584 10.0244 15.9928C10.0267 15.7273 9.97607 15.4639 9.87551 15.2181C9.77495 14.9723 9.62644 14.749 9.43866 14.5612C9.25087 14.3734 9.02757 14.2249 8.78177 14.1244C8.53598 14.0238 8.27262 13.9732 8.00706 13.9755C7.7415 13.9778 7.47906 14.033 7.23506 14.1378C6.99105 14.2426 6.77036 14.395 6.58587 14.586C6.22155 14.9632 6.01996 15.4684 6.02452 15.9928C6.02907 16.5172 6.23941 17.0188 6.61023 17.3896C6.98104 17.7605 7.48267 17.9708 8.00706 17.9754C8.53146 17.9799 9.03666 17.7783 9.41386 17.414Z",
    fill: "#B9B8C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiCredentialsIcon);
export default __webpack_public_path__ + "static/media/api_credentials_icon.f19047c4e9430ab9e8f4ecc74bd59aae.svg";
export { ForwardRef as ReactComponent };